import { FunctionComponent } from "react";
import { Link } from "react-router-dom";
import { ReactComponent as LogoFooter } from '../../../assets/logo-white.svg';
import { 
  FOOTER_CONTACT, 
  FOOTER_NAVIGATION_LINKS, 
  FOOTER_ACCOUNT_LINKS, 
  FOOTER_LEGAL_LINKS,
  COPYRIGHT_YEAR,
  COMPANY_NAME 
} from "src/utils/types/footer";
import { FooterLink } from "src/utils/types/NavigationTypes";


const Footer: FunctionComponent = () => (
  <footer className="w-full bg-primary flex flex-col-reverse justify-center items-center lg:flex-row lg:justify-between lg:items-start px-8 lg:h-[200px]">
    <CompanySection />
    <LinksSection />
  </footer>
);


const CompanySection: FunctionComponent = () => (
  <div className="h-full flex flex-col justify-around">
    <CompanyLogo />
    <CopyrightNotice />
  </div>
);


const CompanyLogo: FunctionComponent = () => (
  <Link to={'/'}>
    <LogoFooter id='footer-logo' height='100px' width='160px' />
  </Link>
);


const CopyrightNotice: FunctionComponent = () => (
  <p className="text-white text-xs">
    &copy; {COPYRIGHT_YEAR} {COMPANY_NAME}. All rights reserved.
  </p>
);


const LinksSection: FunctionComponent = () => (
  <div className="h-full flex justify-around w-full flex-wrap lg:w-[45%]">
    <NavigationColumn />
    <AccountColumn />
    <ContactColumn />
  </div>
);


const NavigationColumn: FunctionComponent = () => (
  <div className="h-full py-3 flex flex-col justify-evenly items-start">
    {FOOTER_NAVIGATION_LINKS.map((link, index) => (
      <FooterLinkComponent key={index} link={link} />
    ))}
  </div>
);


const AccountColumn: FunctionComponent = () => (
  <div className="h-full py-3 flex flex-col justify-evenly items-start">
    {FOOTER_ACCOUNT_LINKS.map((link, index) => (
      <FooterLinkComponent key={index} link={link} />
    ))}
    {FOOTER_LEGAL_LINKS.map((link, index) => (
      <FooterLinkComponent key={index} link={link} />
    ))}
  </div>
);


const ContactColumn: FunctionComponent = () => (
  <div className="h-full py-3 flex flex-col justify-evenly items-start">
    <PhoneNumber />
    <EmailAddress />
  </div>
);


const FooterLinkComponent: FunctionComponent<{ link: FooterLink }> = ({ link }) => (
  <Link 
    to={link.link} 
    className='text-md text-white hover:text-black hover:font-bold hover:underline transition-all duration-200'
    {...(link.external && { target: "_blank", rel: "noopener noreferrer" })}
  >
    {link.name}
  </Link>
);


const PhoneNumber: FunctionComponent = () => (
  <p className='text-md text-white'>{FOOTER_CONTACT.phone}</p>
);


const EmailAddress: FunctionComponent = () => (
  <a href={`mailto:${FOOTER_CONTACT.email}`} className='text-md text-white'>
    {FOOTER_CONTACT.email}
  </a>
);


export default Footer;





